

export class MerchantSettings {
    id: string;
    code: string;
    description: string;
    value: string;
    merCode: string;
    syncToAws: boolean;
}


export class  MerchantSettingsSearchingCriteria{
    code: string;   
    value: string;
    merCode: string;
    description: string;
}
